'use client';

import React, { useCallback, useRef } from 'react';
import { BottomSheet } from '../../components/ui';
import { useLocalTranslation } from '../../hooks/useLocalTranslation';
import { UpgradeInventoryList } from './UpgradeInventoryList';
import translations from './UpgradeScreen.translations';
import type { UpgradeItem } from './UpgradeScreen';

interface UpgradeSourceSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectItem: (item: UpgradeItem) => void;
}

export const UpgradeSourceSheet: React.FC<UpgradeSourceSheetProps> = ({ isOpen, onClose, onSelectItem }) => {
  const { t } = useLocalTranslation(translations);
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const handleSelect = useCallback((item: UpgradeItem) => {
    onSelectItem(item);
    onClose();
  }, [onSelectItem, onClose]);

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title={t('selectSourceItem')} scrollRef={scrollRef}>
      <UpgradeInventoryList onSelectItem={handleSelect} scrollRef={scrollRef} />
    </BottomSheet>
  );
};
